module.exports = __webpack_public_path__ + "img/5f3c3b3f46d1d6784d1ec3d71c34b03b.png";